<script lang="ts" setup>
import { useEditorElements } from '../hooks/useEditorElements';
import SnippetCategoryVue from './SnippetCategory.vue';
import SidebarOverlay from './SidebarOverlay.vue';
type TProps = {
  isShow: boolean;
};
const { isShow } = defineProps<TProps>();
const {
  isRunningAbTest,
  sidePanelsWrapperClass,
  sidePanelClass,
  isLoadingSnippet,
  snippetCategories,
  isOverlayElementSetting,
} = useEditorElements();
</script>

<template>
  <div v-show="isShow" class="side-panels" :class="sidePanelsWrapperClass">
    <div v-if="isRunningAbTest" class="ab-test__blocking"></div>
    <div id="md-snippets" class="side-panel active" :class="sidePanelClass">
      <div class="gfModalFilter">
        <input type="text" name="snippet-filter" value="" placeholder="Search element..." autocomplete="off" />
        <button class="modal-search">
          <i>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <g>
                <path
                  d="M7.42622 2.19258C9.48552 3.02355 10.4813 5.36658 9.65032 7.42588C8.81935 9.48519 6.47632 10.481 4.41702 9.64998C2.35771 8.81901 1.36195 6.47598 2.19292 4.41668C3.02388 2.35738 5.36692 1.36161 7.42622 2.19258"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9.16016 9.16016L12.3521 12.3521" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
          </i>
        </button>
      </div>
      <div class="md-body optiscroll is-enabled has-vtrack">
        <div class="optiscroll-content" style="right: -8px; bottom: -8px">
          <div class="all-snippets">
            <div v-if="isLoadingSnippet" class="gf_snippet-container gf-snippet-category" data-cat="base">
              <div class="gf_snippets-list">
                <div v-for="i in 20" :key="i" class="snippet-wrap show">
                  <div class="skeleton skeleton-dark gf_snippet-skeleton gf_snippet-skeleton--box"></div>
                </div>
              </div>
            </div>
            <SnippetCategoryVue v-for="item in snippetCategories" v-else :key="item.id" :item="item" />
          </div>
        </div>
      </div>
    </div>
    <div id="md-settings" class="side-panel">
      <span class="md-title">Module</span>
      <div class="md-about"></div>
    </div>
  </div>
  <div v-show="isShow" class="side-tools">
    <ul>
      <li title="Elements" class="active">
        <span>
          <i class="fa fa-th" aria-hidden="true"></i>
        </span>
      </li>
    </ul>
  </div>
  <SidebarOverlay v-if="isOverlayElementSetting" />
</template>
<style scoped lang="scss">
.gf_snippet {
  &-container {
    width: calc(100% + 9px);
    margin-top: 8px;
  }
  &-skeleton {
    height: 19px;
    display: inline-block;
    overflow: hidden;
    margin: 0 !important;
    background: #323232;
    border-radius: 3px;
    cursor: not-allowed !important;
    background: #323232;
    color: #fdfdfd;
    border-radius: 4px;
    padding: 15px 5px;
    &--box {
      width: 100%;
      height: 96px;
    }
  }
}
</style>
